import React from "react";
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Container, Row, Col, Card, CardBody } from "shards-react";

@inject(({ teamUser }) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({ common }) => ({ updateDoc: common.updateDoc }))

@observer
class SnsCallback extends React.Component {
  @observable isProcessing = true;
  @observable store = {};
  @observable errorMessage = null;

  componentDidMount() {
    // 디버깅: window.opener 상태 확인
    console.log('=== SnsCallback 디버깅 ===');
    console.log('window.opener:', window.opener);
    console.log('window.opener is null:', window.opener === null);
    console.log('window.opener is undefined:', window.opener === undefined);

    if (window.opener) {
      console.log('window.opener.closed:', window.opener.closed);
      console.log('window.opener.location:', window.opener.location);
    }

    // sessionStorage에서 팝업 정보 확인
    const popupId = sessionStorage.getItem('oauth_popup_id');
    const popupPlatform = sessionStorage.getItem('oauth_popup_platform');
    const popupOpened = sessionStorage.getItem('oauth_popup_opened');
    console.log('sessionStorage - popup_id:', popupId);
    console.log('sessionStorage - platform:', popupPlatform);
    console.log('sessionStorage - popup_opened:', popupOpened);
    console.log('========================');

    // OAuth 처리 진행
    this.handleCallback();
  }

  @action
  handleCallback = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const platform = this.getPlatformFromPath();

    // 복귀할 URL 가져오기
    const returnUrl = sessionStorage.getItem('oauth_return_url') || '/snsSetting';

    console.log('=== OAuth 처리 시작 ===');
    console.log('platform:', platform);
    console.log('code:', code ? 'exists' : 'null');
    console.log('state:', state ? 'exists' : 'null');
    console.log('returnUrl:', returnUrl);
    console.log('=====================');

    // 에러 처리
    if (error) {
      const errorMessage = `인증 실패: ${error}`;
      this.saveCallbackData({
        type: 'oauth_error',
        platform: platform,
        message: errorMessage
      });

      // 원래 페이지로 리다이렉트
      setTimeout(() => {
        window.location.href = returnUrl;
      }, 1000);
      return;
    }

    // 인증 코드 확인
    if (!code) {
      const errorMessage = '인증 코드가 없습니다.';
      this.saveCallbackData({
        type: 'oauth_error',
        platform: platform,
        message: errorMessage
      });

      // 원래 페이지로 리다이렉트
      setTimeout(() => {
        window.location.href = returnUrl;
      }, 1000);
      return;
    }

    try {
      // 백엔드에 인증 코드 전송
      const storeId = this.props.me && this.props.me.store ? this.props.me.store._id : null;
      const teamUser = this.props.me;

      // redirectUri는 Facebook에 등록된 것과 동일해야 함
      const redirectUri = `${window.location.origin}${window.location.pathname}`;

      const params = {
        store_id: storeId,
        shopNo: teamUser.selShopNo,
        platform: platform,
        code: code,
        state: state,
        redirectUri: redirectUri
      };

      console.log('=== 백엔드 API 호출 ===');
      console.log('API: processSnsOAuth');
      console.log('params:', params);
      console.log('=====================');

      await this.props.updateDoc('processSnsOAuth', params, (res, errors) => {
        console.log('=== API 응답 ===');
        console.log('전체 응답:', res);
        console.log('errors:', errors);
        console.log('===============');

        // 에러 체크 (GraphQL errors)
        if (errors && errors.length > 0) {
          console.error('❌ API 에러:', errors);
          const errMsg = errors[0].message || 'SNS 연동 처리 중 오류가 발생했습니다.';
          this.errorMessage = errMsg;
          this.saveCallbackData({
            type: 'oauth_error',
            platform: platform,
            message: errMsg
          });

          // 에러 메시지 확인 시간을 충분히 주고 원래 페이지로 리다이렉트
          setTimeout(() => {
            window.location.href = returnUrl;
          }, 3000);
          return;
        }

        // 데이터 없음 체크
        if (!res) {
          console.error('❌ 응답 데이터 없음');
          const errMsg = 'SNS 연동 정보를 가져오지 못했습니다.';
          this.errorMessage = errMsg;
          this.saveCallbackData({
            type: 'oauth_error',
            platform: platform,
            message: errMsg
          });

          setTimeout(() => {
            window.location.href = returnUrl;
          }, 3000);
          return;
        }

        // 성공 처리
        console.log('✅ API 성공:', res);

        // 페이지 선택 필요 (Facebook 페이지가 여러 개일 때)
        if (res.requiresPageSelection && Array.isArray(res.pages)) {
          this.saveCallbackData({
            type: 'oauth_page_selection',
            platform: platform,
            pages: res.pages
          });

          setTimeout(() => {
            window.location.href = returnUrl;
          }, 800);
          return;
        }

        // 백엔드 응답 구조:
        // { success: true, platform: 'instagram', username: '...', userId: '...' }
        this.saveCallbackData({
          type: 'oauth_success',
          platform: platform,
          data: res,
          username: res.username || res.pageName || res.blogName || res.channelName,
          userId: res.userId || res.pageId || res.blogId || res.channelId
        });

        // 원래 페이지로 리다이렉트
        setTimeout(() => {
          window.location.href = returnUrl;
        }, 1000);
      });
    } catch (error) {
      console.error('OAuth 처리 오류:', error);
      this.saveCallbackData({
        type: 'oauth_error',
        platform: platform,
        message: '연동 처리 중 오류가 발생했습니다.'
      });

      // 원래 페이지로 리다이렉트
      setTimeout(() => {
        window.location.href = returnUrl;
      }, 1000);
    }
  };

  getPlatformFromPath = () => {
    const path = window.location.pathname;
    if (path.includes('instagram')) return 'instagram';
    if (path.includes('facebook')) return 'facebook';
    if (path.includes('naver')) return 'naver';
    if (path.includes('youtube')) return 'youtube';
    return '';
  };

  // localStorage에 콜백 데이터 저장 (다음 페이지에서 사용)
  saveCallbackData = (message) => {
    console.log('saveCallbackData 호출:', message);

    const callbackData = {
      ...message,
      timestamp: Date.now()
    };

    localStorage.setItem('oauth_callback_data', JSON.stringify(callbackData));
    console.log('localStorage에 저장 완료:', callbackData);
  };

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="h-100 align-items-center justify-content-center">
          <Col md="6">
            <Card>
              <CardBody className="text-center p-5">
                {this.errorMessage ? (
                  <>
                    <div className="mb-4">
                      <i className="material-icons" style={{fontSize: '48px', color: '#dc3545'}}>error_outline</i>
                    </div>
                    <h5 className="text-danger">오류</h5>
                    <p className="text-muted">{this.errorMessage}</p>
                    <p className="text-muted" style={{fontSize: '0.85rem'}}>3초 후 SNS 설정 페이지로 이동합니다...</p>
                  </>
                ) : (
                  <>
                    <div className="mb-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                    <h5>SNS 연동 처리 중...</h5>
                    <p className="text-muted">잠시만 기다려주세요.</p>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SnsCallback;
